import { memo, useMemo } from "react";

import Timestamp from "components/Timestamp";
import { formatDate } from "utils/date";
import { unixTimestampToMs } from "utils/time";

import { type RenderGroupRowCellProps } from ".";
import useCellCopyAction from "../useCellCopyAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellUpdatedAt = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const formattedTimestamp = formatDate({
    date: unixTimestampToMs(row.updatedAt),
  });
  const copyAction = useCellCopyAction(ResourcesSuggestions.UpdatedAt, formattedTimestamp);
  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      <Timestamp timestamp={row.updatedAt} />
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellUpdatedAt.displayName = "IacManagementTableGroupRowCellUpdatedAt";

export default IacManagementTableGroupRowCellUpdatedAt;
